<template>
  <v-autocomplete
    auto-select-first
    v-bind:value="selectedValue"
    v-on:input="updateValue($event)"
    :disabled="isEmpty(vehicleOptions)"
    :items="vehicleOptions"
    :error-messages="errorMessages"
    :loading="loading"
    :placeholder="$t('type_trailer_number')"
    prepend-inner-icon="mdi-truck"
    :label="$tc('vehicle')"/>
</template>

<script>
/**
 * Autocomplete picker for vehicles. Given a customer, will fetch all vehicles for that customer, and emits the selected
 * VehicleRecord object upon selection.
 */
import { map, isEmpty, find, get } from 'lodash'

export default {
  name: 'VehiclePicker',
  props: {
    customer: Object,
    value: Object,
    errorMessages: Array
  },
  data () {
    return {
      isEmpty: isEmpty,
      loading: false,
      vehicles: []
    }
  },
  computed: {
    /**
     * Computed adapter value for v-autocomplete (which doesn't operate off objects). Uses the vehicle id.
     * @returns {Number}
     */
    selectedValue () {
      return get(this.value, 'id')
    },
    /**
     * Map the retrieved vehicles into an options array for v-autocomplete.
     * @returns {Array}
     */
    vehicleOptions () {
      return map(this.vehicles, x => {
        return {
          value: x.id,
          text: x.name
        }
      })
    }
  },
  methods: {
    updateValue (value) {
      const selectedVehicle = find(this.vehicles, x => x.id === value, 0)
      this.$emit('input', selectedVehicle)
    },
    /**
     * Fetch the vehicles used in the picker options.
     */
    async fetchVehicles () {
      try {
        this.loading = true
        const response = await this.$orm('Vehicle').findAll({
          customer_id: this.customer.id,
          service_provider_id: '!null',
          'per-page': 0,
          fields: 'id,name'
        })
        this.vehicles = response.getItems()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.fetchVehicles()
  },
  watch: {
    // If the customer property changes, re-fetch the vehicles.
    customer () {
      this.fetchVehicles()
    }
  }
}
</script>

<style scoped>

</style>
